// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3_LCr","footer":"ModalInfo_footer__WJjLR"};